export default __webpack_public_path__ + "static/media/oi_3.d82131d9.mp3";